import type { Recent } from "app/custom-hooks/useRecentsHook";
import { DEFAULT_WEBSITES } from "app/pages/activation/components/HomeSearch/config";
import { createDefaultWebsiteItems } from "app/pages/activation/components/HomeSearch/helpers/createDefaultWebsiteItem";
import { createRecentWebsiteItem } from "app/pages/activation/components/HomeSearch/helpers/createRecentWebsiteItem";
import { generateWebsiteResponse } from "app/pages/activation/components/HomeSearch/helpers/generateWebsiteResponse";
import type { OnSearchItemClick } from "app/pages/activation/components/HomeSearch/types";

type GetWebsitesItemsSchema = {
    query: string;
    recentWebsites: Recent[];
    onClick?: OnSearchItemClick;
};

export const getWebsitesItems = async ({ query, recentWebsites, onClick }: GetWebsitesItemsSchema) => {
    const hasQuery = !!query?.length;
    const hasRecent = !!recentWebsites.length;

    if (hasQuery) {
        return await generateWebsiteResponse(query, onClick);
    }

    if (hasRecent) {
        return recentWebsites.map((site) => createRecentWebsiteItem(site, onClick, site.data.stateName));
    }

    return await createDefaultWebsiteItems(DEFAULT_WEBSITES, onClick);
};
